import * as getters from '@/store/modules/transfers/kwik/getters'
import * as mutations from '@/store/modules/transfers/kwik/mutations'
import * as actions from '@/store/modules/transfers/kwik/actions'

const state = {
	cardsList: [],
    accountAlias: [],
    smsPhoneNumber: null,
    customer: {},
    plafond: [],
    transactionLimit: []
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
